export default "__VITE_ASSET__68f0a18c__"